export const Start = 'Start'
export const Done = 'Done'
